import React, { useEffect } from "react";
import * as api from "./api/index";

import "./Index.css";
import "./styles/main.scss";
import { useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loadUser } from "./actions/userActions";
import Routes from "./Routes";
import jwtDecode from "jwt-decode";
import { QueryClient, QueryClientProvider, useQuery } from "react-query";
import LoadingSpinner from "./Components/Spinner/Spinner";
import ScrollToTop from "./Components/ScrollToTop";
import IdleTimer from "./helpers/IdleTimer";
import { useHistory } from "react-router-dom";

function App() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  // console.log(token);
  if (token === "undefined" || token === undefined) {
    localStorage.removeItem("token");
    history.push("/");
  }

  const logoutHandler = async () => {
    const result = await api.logoutApi();
    if (result?.status === 200) {
      localStorage.removeItem("token");
      localStorage.removeItem("auth");
      window.location.pathname = "/";
    }
  };

  const queryClient = new QueryClient();
  queryClient.setDefaultOptions({
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
    staleTime: 1000 * 6,
  });

  useEffect(() => {
    if (token) {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      if (decoded.exp < currentTime) {
        localStorage.removeItem("token");
        history.push("/login");
      }
      dispatch(loadUser());
    } else {
      dispatch(loadUser());
    }
  }, []);

  return (
    <div className="app-container">
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ScrollToTop />
          {loading ? <LoadingSpinner /> : <Routes />}
          <IdleTimer onIdle={logoutHandler} />
        </BrowserRouter>
      </QueryClientProvider>
    </div>
  );
}

export default App;
